import type IncomingMessage from './IncomingMessage';

/**
 * Handle messages from the native app.
 *
 * @example
 * type AddFavoriteMessage = IncomingMessage<
 *   Event,
 *   {
 *     stockNumber: number;
 *     vehicleId: number;
 *   }
 * >;
 *
 * function isAddFavoriteMessage(
 *   message: IncomingMessage<Event, any>
 * ): message is AddFavoriteMessage {
 *   return (
 *     message.event === Event.AddFavorite &&
 *     message.payload.stockNumber != null &&
 *     message.payload.vehicleId != null
 *   );
 * }
 *
 * export default function useAddFavoriteHandler(): MessageHandler<Event> {
 *   return useMemo(
 *     () =>
 *       new MessageHandler(
 *         isAddFavoriteMessage,
 *         (message: AddFavoriteMessage) => {
 *           console.log(message.payload);
 *         }
 *       ),
 *     [addFavorite]
 *   );
 * }
 */

export default class MessageHandler<
  Event,
  Payload extends Record<string, any> = any
> {
  constructor(
    public readonly test: (
      message: IncomingMessage<Event, any>
    ) => message is IncomingMessage<Event, Payload>,
    public readonly handle: (message: IncomingMessage<Event, Payload>) => void
  ) {}
}
